import { Component, Vue, Prop } from 'vue-facing-decorator'
import { ActionHandler } from "../helpers";
import type { MessageContentSettings, MessageStructureComponent } from "../types";
import { STORE_MUTATION } from "../enums/store_mutation";
import { store } from "../store/store";
import { Util } from '../util';

@Component
export default class QuickReply extends Vue {
  //property
	@Prop({
		type: Array,
		default: []
	})
	data?: MessageStructureComponent[];

	@Prop({
		type: Number,
		default: -1
	})
	msgIndex?: number;

	@Prop({
		type: Object,
		default() {
			return {}
		}
	})
	
	messageContentsettings?: MessageContentSettings

	@Prop({ type: [String, Number] })
  messageId!: string | number;


	/**
	 * This is used to determine if the font is fully loaded
	 */
	isFontLoaded = false;
	lastClickedButton: HTMLElement | null = null;

	/**
	 * At this stage, the Vue instance has been initialized
	 */
	created() {
        this.listenEvents();
    }

	onClick(index, event) {
    const clickedButton = event.currentTarget as HTMLElement;
    this.lastClickedButton = clickedButton;
    this.data[index].messageId = this.messageId;
		
    const result = ActionHandler.handleBtnClickAction(this.data[index]);
    
    // If this is the language selector quick reply
    if (this.data[index].clickAction?.postback === "response_name=language_selector_modal") {
        // Store the button in the store for the modal to access
        store.commit(STORE_MUTATION.SetLastFocusedElement, clickedButton);
    }
    
    return result;
	}

	/**
	 * SD-1706
	 * This is used to listen to needed events
	 */
	listenEvents() {
		try {
			// Check if all fonts in use by visible text have loaded.
			(document as any).fonts.ready
				.then(() => {
					console.log('All fonts in use by visible text have loaded.');
					this.isFontLoaded = true;
				}).catch((err) => {
					this.isFontLoaded = true;
				});

		} catch (ex) {
            //var errorObj = { Page: 'quick_reply.ts', MethodName: 'listenEvents', Message: ex.message };
            //console.log(errorObj);
        }
	}
	
	formatMessageContent(messageContent:string){
		return Util.formatTextWithAccessibleEmojis(messageContent)
	}
}
